import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabsModule } from '../core-ui/Tabs/Tabs.module';
import { BasicPageBodyComponent } from './basic-page-body.component';
import { BasicPageHeaderComponent } from './basic-page-header.component';
import { BasicPageLayoutComponent } from './basic-page-layout.component';
import { BasicPageSideNavigationComponent } from './basic-page-side-navigation.component';
import { DashboardComponent } from './dashboard.component';
import { GradientHeaderComponent } from './gradient-page-header.component';
import { GradientPageLayoutComponent } from './gradient-page-layout.component';
import { TabbedPageLayoutComponent } from './tabbed-page-layout.component';

@NgModule({
    imports: [CommonModule, TabsModule],
    declarations: [
        BasicPageBodyComponent,
        BasicPageHeaderComponent,
        GradientHeaderComponent,
        BasicPageSideNavigationComponent,
        BasicPageLayoutComponent,
        GradientPageLayoutComponent,
        TabbedPageLayoutComponent,
        DashboardComponent
    ],
    exports: [
        BasicPageBodyComponent,
        BasicPageLayoutComponent,
        BasicPageSideNavigationComponent,
        TabbedPageLayoutComponent,
        GradientHeaderComponent,
        DashboardComponent,
        GradientPageLayoutComponent
    ],
    providers: []
})
export class PageLayoutsModule {}
